<template>
    <aside class="aside-menu d-lg-none" :class="{ 'aside-menu-active': menuOpen }">
      <div class="aside-menu-itens">
        <div class="menu-header">
          <div class="aside-menu-itens-header">
            <div class="content-menu">
              <a class="content-menu-item btn-menu" @click="setMenuOpen(false)">
                <!-- <span class="active"></span> -->
                <svg xmlns="http://www.w3.org/2000/svg" width="10.578" height="17.787" viewBox="0 0 10.578 17.787">
                    <path id="Union_2" data-name="Union 2" d="M15.787,0,7.894,8.578ZM0,0,7.894,8.578Z" transform="translate(1 16.787) rotate(-90)" fill="none" stroke="#fff" stroke-linecap="square" stroke-linejoin="round" stroke-width="2"/>
                </svg>
              </a>
            </div>
          </div>
          <div class="aside-menu-itens-links">
            <router-link tag="a" to="/" @click.native="setMenuOpen(false)" class="links v-content-menu" :class="{ 'link-active': $route.name === 'Client' }" v-contentMenu="{ section: 'Menu', removeHtml: true }"> 
              Cliente
            </router-link>
            <router-link tag="a" to="/comerciante" @click.native="setMenuOpen(false)" class="links v-content-menu" :class="{ 'link-active': $route.name === 'Merchant' }" v-contentMenu="{ section: 'Menu', removeHtml: true }"> 
              Comerciante
            </router-link>
            <button @click="openLogin" class="links v-content-menu" :class="{ 'link-active': $route.name === 'Account' }" v-contentMenu="{ section: 'Menu', removeHtml: true }">
              A sua conta
            </button>
          </div>
        </div>
        <div>
            <!-- <div>
                <LanguageList />
            </div> -->
            <div class="client-end" v-if="isAuthenticated">
                <button class="v-content-menu" v-contentMenu="{ section: 'Menu', removeHtml: true }" @click.native="setMenuOpen(false)" @click="logOut()">Terminar Sessão</button>
            </div>
            <img src="@/assets/img/logo-white.png" alt="" width="82" height="27" class="mt-2">
        </div>
      </div>
    </aside>
  </template>
  
  <script>
  import { mapGetters, mapActions, mapState } from "vuex";
  import axios from 'axios';
  import store from '@/store';
  // import LanguageList from "../headers/LanguageList.vue";
  
  const allContents = [];
  const lang = localStorage.getItem('locale') || 'es';
  
  export default {
    name: "Menu", 
    data() {
      return {
        activeChat: false,
      };
    },
    computed: {
      ...mapGetters(["menuOpen", 'isAuthenticated']),
      ...mapState('App', ['loading']),
      isAuthenticated() {
        return this.$store.getters['App/isAuthenticated'];
      }
    },

    watch: {
      isAuthenticated(newVal) {
        console.log('Auth mudou:', newVal);

        if (!newVal) {
          this.$router.push('/');
        }
      }
    },
    methods: {
      ...mapActions({
        setMenuOpen: "setMenuOpen",
      }),
      ...mapActions('App', ['setLogout']),
      goToAccount(){
        this.$router.push('/cuenta');
      },
      openLogin() {
        this.setMenuOpen(false);

        if (localStorage.getItem('token') && localStorage.getItem('token') !== 'undefined') {
          this.$router.push('/cuenta');
          return;
        }

        this.$bvModal.show('modal-login'); // 🔥 chama o Login global do App.vue
      },
      async logOut() {
        this.setMenuOpen(false);

        await this.setLogout(); // <-- AGUARDA finalizar

        this.$swal.fire({
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        });

        this.$router.replace('/');
      },
      updateDirectives() {
        const allElements = document.querySelectorAll('.v-content-menu');
        allContents.splice(0, allContents.length); // clear the contents array
          allElements.forEach((el) => {
              const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
              params.content = el.innerHTML.trim();
              if (!('type' in params)) params.type = 'text';
              params.theme = process.env.VUE_APP_THEME;
              params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
              allContents.push(params);
          });
      },
    },
    directives: {
      contentMenu: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-menu');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
              .then(response => response.data)
              .then((data) => {
  
                const allElements = document.querySelectorAll('.v-content-menu');
                allContents.forEach((el) => {
                  if (el.type == 'text') {
                    allElements.forEach((el, index) => {
                      el.innerHTML = data.data[index];
                    });
                  }
                });
                store.dispatch('App/loading', false);
              });
          }
        },
  
      }
    },
  };
  </script>
  
  <style lang="scss">
  .link-active {
    border-bottom: 2px solid var(--white)!important;
  }
  .aside-menu {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 90%;
    height: 100%;
    background: var(--main-color);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    transition: 0.8s ease-in-out;
    right: -100%;
    pointer-events: none;
    z-index: 1030;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    @media (max-width: 359px){
      width: 100%;
    }
    &-active {
      right: 0;
      pointer-events: initial;
    }
    &-itens {
      display: flex;
      flex-direction: column;
      align-content: flex-end;
      align-items: flex-end;
      justify-content: space-between;
      padding: 55px 25px 100px 25px;
      height: 100vh;
      &-header {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        img {
          max-width: 120px;
        }
        .content-menu {
          display: flex !important;;
          align-items: center;
          justify-content: flex-end;
          width: 100%;
          &-item {
            width: 47px;
            height: 45px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            text-decoration: none !important;
            border-radius: 10px;
            padding-top: 0;
            span {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 0;
              &::before, &::after {
                width: 20px
              }
            }
          }
        }
      }
      &-links {
        width: 100%;
        margin-top: 60px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        a {
          display: block;
          font-family: "Font Regular";
          color: var( --white) !important;
          font-size: 26px;
          line-height: 39px;
          margin-bottom: 0;
          width: 100%;
          padding: 15px 0px;
          transition: 500ms;
          text-decoration: none;
          &:hover,
          &:focus {
            cursor: pointer;
            opacity: 0.8;
          }
        }
        button {
          all: unset;
          display: block;
          font-family: "Font Regular";
          color: var( --white) !important;
          font-size: 26px;
          line-height: 39px;
          margin-bottom: 0;
          width: 100%;
          padding: 15px 0px;
          transition: 500ms;
          text-decoration: none;
          &:hover,
          &:focus {
            cursor: pointer;
            opacity: 0.8;
          }
        }
        .links {
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          gap: 60px;
          a {
            width: 100%;
            font-family: "Font Regular";
            color: var( --white) !important;
            font-size: 26px;
            line-height: 39px;
            margin-bottom: 0;
            text-transform: capitalize;
            text-align: left;
          }
          &-icon {
            height: 56px;
            width: 56px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: var(--white);
            border-radius: 100%;
            margin-left: 10px;
            svg {
              fill: #3FBA90;
              max-width: 30px;
            }
          }
        }
      }
      .card {
        border: 0;
        background: 0;
        border-radius: 0px;
        &-header {
          border: 0;
          background: 0;
          border-radius: 0px;
          padding: 0;
        }
        .btn-link {
          padding: 15px;
          padding-bottom: 0px;
          font-size: 20px;
          color: var( --green-dark);
          font-family: "Font Bold";
          border: 0;
          width: 100%;
          text-decoration: none;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          box-shadow: none;
          & > div {
            transition: 500ms;
            margin-left: 10px;
            svg {
              fill: var( --green-medium);
              transition: 500ms;
            }
          }
        }
        [aria-expanded="true"] {
          opacity: 0.8;
          & > div {
            transform: rotate(180deg);
          }
        }
        &-body {
          padding: 0;
          &-links {
            display: flex;
            align-items: center;
            height: 40px;
            width: 100%;
            padding-left: 30px;
            color: var( --green-dark);
            font-size: 14px !important;
            letter-spacing: 1.5px;
            font-family: "Font Light";
            transition: 500ms;
            &:hover,
            &:focus {
              cursor: pointer;
            }
          }
        }
      }
      &-collapse {
        &-btn {
          font-family: "Font Regular";
          color: var( --green-dark) !important;
          background: 0;
          border: 0;
          font-size: 20px;
          display: block;
          width: 100%;
          padding: 15px;
          transition: 500ms;
          text-align: left;
          display: flex;
          align-items: center;
          p{
            padding-bottom: 0;
            margin-bottom: 0;
            font-size: 18px;
            font-family: "Font Regular", sans-serif;
            color: var( --green-medium);
            span{
              font-size: 18px;
              font-family: "Font Regular", sans-serif;
              color: var( --green-dark);
            }
          }
      
          & > div {
            transition: 500ms;
            margin-left: 7px;
            svg {
              fill: var( --green-medium);
              transition: 500ms;
            }
          }
          &[aria-expanded="true"] {
            opacity: 0.8;
            & > div {
              transform: rotate(180deg);
            }
          }
        }
      }
      div {
        &.client-end {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          padding-bottom: 30px;
          button {
            all: unset;
            color: var(--white);
            font-family: 'Font Regular';
            font-size: 18px;
            line-height: 27px;
            &:hover,
            &:focus {
              cursor: pointer;
              opacity: 0.8;
            }
          }
        }
       img {
         max-width: 120px;
       }
      }
    }
  }
  .dropdown {
    position: relative;
    display: inline-block;
  }
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    padding: 12px 16px;
    z-index: 1;
    .btn-logout{
      all: unset;
      color: #878787;
      margin-top: 10px;
    }
    .account{
      text-decoration: none;
      color: #878787;
    }
  }
  .dropdown:hover .dropdown-content {
    display: block;
  }
  .content-buttons{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-bottom: 30px;
  }
  .menu-header{
    width: auto;
    height: 400px;
  }
  .menu-footer{
    margin: 50px 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 30px;
    height: 352px;
    &-links{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      gap: 30px;
      width: 100%;
      p{
        font-size: 12px;
        font-family: 'Font Bold';
        color: var(--white);
        line-height: 19px;
        margin-bottom: 0;
        text-align: right;
        text-transform: uppercase;
        &:hover,&:focus {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }
    &-logo{
      img{
        width: 110px;
        height: auto;
      }
    }
  }
  </style>